import{ useState, useContext } from "react";
import { Button, TextField, Typography } from "@mui/material";
import { reducerContext } from "../../../../contextApi's/contextApi's";
import snackError from "../../../../helpers/snackError";

import { httpRequest } from "../../../../ui-utils/api";
import { backendHosts, apiUrl } from "../../../../ui-utils/apiConfig";
import axios from "axios";

const FaqTag = () => {
    const { dispatch } = useContext(reducerContext)

    const [tagName, setTagName] = useState('')
    const [errors, setErrors] = useState({})

    const validateTagFields = () => {
        const newErrors = {}

        if (!tagName.trim()) {
            newErrors.tagName = "Tag name is required"
        }

        return newErrors
    }

    const handleCreateTag = async () => {
        const validationErrors = validateTagFields()

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        try {

            const createdTag = await axios.post(`${backendHosts.ADMIN}${apiUrl.faqTags}`, { tag_name: tagName })
            // const createdTag = await httpRequest({
            //     endPoint: `${backendHosts.ADMIN_REPORT}${apiUrl.faqTags}`,
            //     method: "post",
            //     instance: "instanceOne",
            //     requestBody: { tag_name: tagName },
            // })

            if (createdTag.data?.status === 201) {
                dispatch({
                    type: 'ADD_FAQ_TAG',
                    payload: createdTag.data?.tagResult,
                })

                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: createdTag.data?.message })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.mySucc })

                setTagName('')
                setErrors('')
            }

        } catch (error) {
            console.log("Error while creating tag:", error)
            dispatch({ type: 'SET_SHOW_ERROR', payload: true })
            dispatch({ type: 'SET_ERROR', payload: error.error })
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
        }
    }

    return (
        <>
            <Typography variant="h6" fontWeight="bold">
                Tag:
            </Typography>
            <TextField
                label="Tag Name"
                margin="normal"
                fullWidth
                value={tagName}
                onChange={(e) => setTagName(e.target.value)}
                error={!!errors.tagName}
                helperText={errors.tagName}
                autoComplete="new-password"
            />

            <Button onClick={handleCreateTag} variant="contained" color="primary" sx={{ mt: 2, mb: 3 }}>
                Create Tag
            </Button>
        </>
    )
}

export default FaqTag
